const executionLang = {
  en: {
    budgetExecution: "Budget execution",
    settlement: "Settlement",
    changeLiquidator: "Change Liquidator",
    currentLiquidator: "Current Liquidator",
    newLiquidator: "New Liquidator",
    selectNewLiquidator: "Select new liquidator",
    changeReason: "Change Reason",
    enterChangeReason: "Enter the reason for the change",
    liquidatorChangedSuccessfully: "Liquidator changed successfully",
    errorChangingLiquidator: "Error changing liquidator",
    errorLoadingUsers: "Error loading users",
    notAssigned: "Not assigned",
  },
  es: {
    budgetExecution: "Ejecución presupuestaria",
    settlement: "Liquidaciones",
    changeLiquidator: "Cambiar usuario liquidante",
    currentLiquidator: "Liquidante actual",
    newLiquidator: "Nuevo liquidante",
    selectNewLiquidator: "Selecciona el nuevo liquidante",
    changeReason: "Motivo del cambio",
    enterChangeReason: "Ingresa el motivo del cambio",
    liquidatorChangedSuccessfully: "Liquidador cambiado exitosamente",
    errorChangingLiquidator: "Error al cambiar liquidante",
    errorLoadingUsers: "Error al cargar usuarios",
    notAssigned: "No asignado",
  },
};
export default executionLang;
